import { useEntitlementCheck } from '@/hooks/entitlements'

/**
 * Hook to check if the current billing organization has SharePoint entitlement.
 * Uses SpiceDB-based entitlement checks.
 *
 * @returns boolean indicating whether the organization has SharePoint entitlement (defaults to false while loading)
 */
export const useCanEnableSharepoint = () => {
  const { data } = useEntitlementCheck({ entitlement: 'sharepoint' })
  return data ?? false
}
